// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  inf = 186,
  nan = 187,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Outer = 7,
  Atan2 = 8,
  Avg = 9,
  Bottomk = 10,
  Count = 11,
  CountValues = 12,
  CardinalityEstimate = 13,
  Group = 14,
  Max = 15,
  Min = 16,
  Quantile = 17,
  LimitK = 18,
  LimitRatio = 19,
  Stddev = 20,
  Stdvar = 21,
  Sum = 22,
  Topk = 23,
  By = 24,
  Without = 25,
  And = 26,
  Or = 27,
  Unless = 28,
  Start = 29,
  End = 30,
  Fill = 31,
  FillLeft = 32,
  FillRight = 33,
  LineComment = 34,
  PromQL = 35,
  AggregateExpr = 36,
  AggregateOp = 37,
  TemplateVariable = 38,
  AggregateModifier = 39,
  GroupingLabels = 40,
  LabelName = 41,
  QuotedLabelName = 42,
  FunctionCallBody = 43,
  BinaryExpr = 44,
  Pow = 45,
  BoolModifier = 46,
  OuterModifier = 47,
  MatchingModifierClause = 48,
  FillModifier = 49,
  FillClause = 50,
  NumberLiteral = 51,
  FillLeftClause = 52,
  FillRightClause = 53,
  Mul = 54,
  Div = 55,
  Mod = 56,
  Add = 57,
  Sub = 58,
  Eql = 59,
  Gte = 60,
  Gtr = 61,
  Lte = 62,
  Lss = 63,
  Neq = 64,
  FunctionCall = 65,
  FunctionIdentifier = 66,
  AbsentOverTime = 67,
  Identifier = 68,
  Absent = 69,
  Abs = 70,
  Acos = 71,
  Acosh = 72,
  Asin = 73,
  Asinh = 74,
  Atan = 75,
  Atanh = 76,
  AvgOverTime = 77,
  Ceil = 78,
  Changes = 79,
  Clamp = 80,
  ClampMax = 81,
  ClampMin = 82,
  Cos = 83,
  Cosh = 84,
  CountOverTime = 85,
  DaysInMonth = 86,
  DayOfMonth = 87,
  DayOfWeek = 88,
  DayOfYear = 89,
  Deg = 90,
  Delta = 91,
  Deriv = 92,
  Exp = 93,
  Floor = 94,
  HistogramCount = 95,
  HistogramFraction = 96,
  HistogramQuantile = 97,
  HistogramStdDev = 98,
  HistogramStdVar = 99,
  HistogramSum = 100,
  HistogramAvg = 101,
  HoltWinters = 102,
  DoubleExponentialSmoothing = 103,
  Hour = 104,
  Idelta = 105,
  Increase = 106,
  Info = 107,
  Irate = 108,
  LabelReplace = 109,
  LabelJoin = 110,
  LastOverTime = 111,
  Ln = 112,
  Log10 = 113,
  Log2 = 114,
  MadOverTime = 115,
  MaxOverTime = 116,
  MinOverTime = 117,
  Minute = 118,
  Month = 119,
  Pi = 120,
  PredictLinear = 121,
  PresentOverTime = 122,
  QuantileOverTime = 123,
  Rad = 124,
  Rate = 125,
  Resets = 126,
  Round = 127,
  Scalar = 128,
  Sgn = 129,
  Sin = 130,
  Sinh = 131,
  Sort = 132,
  SortDesc = 133,
  SortByLabel = 134,
  SortByLabelDesc = 135,
  Sqrt = 136,
  StddevOverTime = 137,
  StdvarOverTime = 138,
  SumOverTime = 139,
  Tan = 140,
  Tanh = 141,
  Timestamp = 142,
  Time = 143,
  Vector = 144,
  Year = 145,
  HistogramObservations = 146,
  HistogramQuantiles = 147,
  SortHeadAvg = 148,
  SortHeadMin = 149,
  SortHeadMax = 150,
  SortHeadSum = 151,
  SortHeadCount = 152,
  SortTailAvg = 153,
  SortTailMin = 154,
  SortTailMax = 155,
  SortTailSum = 156,
  SortTailCount = 157,
  SumPerSecond = 158,
  TsOfFirstOverTime = 159,
  TsOfLastOverTime = 160,
  TsOfMinOverTime = 161,
  TsOfMaxOverTime = 162,
  MatrixSelector = 163,
  Duration = 164,
  OffsetExpr = 165,
  ParenExpr = 166,
  StringLiteral = 167,
  SubqueryExpr = 168,
  UnaryExpr = 169,
  UnaryOp = 170,
  VectorSelector = 171,
  LabelMatchers = 172,
  LabelMatcher = 173,
  MatchOp = 174,
  EqlSingle = 175,
  EqlRegex = 176,
  NeqRegex = 177,
  StepInvariantExpr = 178,
  At = 179,
  AtModifierPreprocessors = 180,
  MetricName = 181
